/* eslint-disable @typescript-eslint/no-explicit-any */
// export const requestFullscreen = (element?: any) => {
//   const el = element || document.body;

//   // Supports most browsers and their versions.
//   const requestMethod =
//     el.requestFullScreen || el.webkitRequestFullScreen || el.mozRequestFullScreen || el.msRequestFullScreen;

//   if (requestMethod) {
//     requestMethod.call(el);
//   } else if (typeof window.ActiveXObject !== 'undefined') {
//     // Older IE.
//     const wscript = new window.ActiveXObject('WScript.Shell');

//     if (wscript !== null) {
//       wscript.SendKeys('{F11}');
//     }
//   }
// };

export const toggleFullScreen = (element?: any) => {
  const el = element || document.documentElement;

  if (!document.fullscreenElement) {
    el.requestFullscreen();
  } else if (document.exitFullscreen) {
    document.exitFullscreen();
  }
};
